import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { MARKETING_PARAMS } from '@/libs/constants';
import { marketingActions } from '@/models/marketing';
const getStringParam = (search, paramName) => {
    const value = search.get(paramName);
    return value || null;
};
const getPartnerId = (search) => {
    const partnerId = search.get('partnerId');
    if (!partnerId) {
        return null;
    }
    const numericPartnerId = Number(partnerId);
    return Number.isFinite(numericPartnerId) && numericPartnerId > 0
        ? numericPartnerId
        : null;
};
const hasMarketingParams = (search) => MARKETING_PARAMS.some((paramName) => search.has(paramName));
const clearMarketingParams = (search) => {
    MARKETING_PARAMS.forEach((paramName) => {
        search.delete(paramName);
    });
    return search.toString();
};
const prepareMarketingParams = (search) => {
    if (!hasMarketingParams(search)) {
        return null;
    }
    const partnerId = getPartnerId(search);
    const srcsale = getStringParam(search, 'srcsale');
    if (!partnerId) {
        return {
            srcsale,
        };
    }
    return {
        partnerId,
        marker: getStringParam(search, 'marker'),
        marker2: getStringParam(search, 'marker2'),
        marker3: getStringParam(search, 'marker3'),
        marker4: getStringParam(search, 'marker4'),
        srcsale,
    };
};
export const useMarketingParams = () => {
    const { pathname, search, hash } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        const urlSearchParams = new URLSearchParams(search);
        const marketingParams = prepareMarketingParams(urlSearchParams);
        if (marketingParams) {
            dispatch(marketingActions.setMarketingParams(marketingParams));
            const clearedSearch = clearMarketingParams(urlSearchParams);
            navigate({
                pathname,
                search: clearedSearch ? `?${clearedSearch}` : '',
                hash,
            }, { replace: true });
        }
    }, [dispatch, hash, navigate, pathname, search]);
};
